'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.lp-checkbox__wrapper {\n  padding: calc(0.5 * 1rem);\n  width: max-content;\n}\n.lp-checkbox__wrapper:hover {\n  background: #f2f7ff;\n}\n.lp-checkbox__wrapper:focus {\n  background: #f2f7ff;\n  outline: none;\n}\n.lp-checkbox__wrapper .lp-checkbox {\n  padding: 0;\n  height: initial;\n  width: initial;\n  margin-bottom: 0;\n  display: none;\n  cursor: pointer;\n}\n.lp-checkbox__wrapper .lp-label:before {\n  content: \"\";\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: 1px solid #989898;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);\n  height: 15px;\n  width: 15px;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-right: 5px;\n  transition: 0.3s ease-in background;\n  border-radius: calc(0.25 * 1rem);\n}\n.lp-checkbox__wrapper .lp-checkbox:checked + .lp-label:before {\n  transition: 0.2s ease-in background;\n  background-color: #1D66DD;\n  border-color: #1D66DD;\n}\n.lp-checkbox__wrapper .lp-checkbox:checked + .lp-label:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 4px;\n  left: 7px;\n  width: 3px;\n  height: 10px;\n  bottom: 2px;\n  border: solid #fff;\n  border-width: 0 1px 1px 0;\n  transform: rotate(45deg);\n}\n\n.lp-disabled {\n  opacity: 0.5;\n  background: transparent;\n}\n.lp-disabled:hover {\n  background: transparent !important;\n}");
//# sourceMappingURL=Checkbox.scss.js.map
